export class Form {
    constructor(formTitle) {
        this.formTitle = formTitle;
    }

    schema() {
        return [
            {
                'component': 'h2',
                'children': this.formTitle,
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'offer',
                        'label': 'Angebotsname (maximal 35 Zeichen)',
                        'class': 'col-12',
                        'placeholder': 'Bitte Namen eingeben...',
                        'validation': 'min:5,length|max:35,length|required',
                        'error-behavior': 'live',
                        'validation-name': 'Angebotsname',
                    },
                    {
                        'type': 'textarea',
                        'name': 'conditions',
                        'label': 'Bedingung (maximal 125 Zeichen)',
                        'help': 'z.B.: Nur solange der Vorrat reicht. Nur ein Gutschein/Person einlösbar.',
                        'class': 'col-12',
                        'error-behavior': 'live',
                        'placeholder': 'Bitte die Bedingungen eingeben...',
                        'validation-name': 'Bedingungen',
                        'validation': 'min:5,length|max:125,length|required',
                    },
                    {
                        'type': 'date',
                        'name': 'valid_from',
                        'label': 'Gültig von',
                        'class': 'col-12 col-md-6',
                        'validation': 'required|date',
                        'validation-name': 'Gültig von ',
                    },
                    {
                        'type': 'date',
                        'name': 'valid_to',
                        'label': 'Gültig bis',
                        'class': 'col-12 col-md-6',
                        'validation': 'required|date',
                        'validation-name': 'Gültig von ',
                    },
                ],
            },
        ];
    }
}
